import React from 'react';

function SingleTag(){

	return <div>
		<h1>Fetching Page...</h1>
	</div>

}
export default SingleTag

